import type { FieldRestorationState } from './types';

export type ReducerAction =
	| {
			type: 'LOADING';
	  }
	| {
			type: 'SUCCESS';
	  }
	| {
			type: 'ERROR';
			error: Error;
	  };

export const reducer = (
	state: FieldRestorationState,
	action: ReducerAction,
): FieldRestorationState => {
	switch (action.type) {
		case 'LOADING': {
			return { loading: true, success: null, error: null, hasRun: true };
		}
		case 'SUCCESS': {
			return { loading: false, success: true, error: null, hasRun: true };
		}
		case 'ERROR': {
			return { loading: false, success: false, error: action.error, hasRun: true };
		}
		default: {
			const invalid: never = action;
			throw new Error(
				`Invalid action passed to useRestoreField reducer ${JSON.stringify(invalid)}!`,
			);
		}
	}
};
